import {Injectable} from '@angular/core'
import {environment} from '../../../environments/environment'

export interface AccountValidationError {
  field: string
  text: string
}

export interface AccountFormValidationData {
  name?: string
  login?: string
  title?: string
  role?: { isCompany?: boolean; [key: string]: unknown }
  company?: string
  address?: {
    address1?: string
    zipCode?: string
    city?: string
    state?: string
  }
  email?: string
  contacts?: {
    phone?: string
    fax?: string
  }
  pwd1?: string
  pwd2?: string
  [key: string]: unknown
}

@Injectable()
export class AccountsValidationService {
  test(data: AccountFormValidationData, isEditMode?: boolean): Promise<boolean> {
    const errors: AccountValidationError[] = []
    // Name
    if (!environment.stringCheck(data.name)) {
      errors.push({
        field: 'name',
        text: 'You should to fill Name field'
      })
    }

    // User Login
    if (!isEditMode) {
      if (!environment.stringCheck(data.login)) {
        errors.push({
          field: 'login',
          text: 'You should to fill User Login field'
        })
      }
    }

    // Job Title
    if (!environment.stringCheck(data.title)) {
      errors.push({
        field: 'title',
        text: 'You should to fill Job Title field'
      })
    }

    // Role
    if (!isEditMode) {
      if (!environment.stringCheck(data.role as unknown as string)) {
        errors.push({
          field: 'role',
          text: 'You should to select Role'
        })
      } else {
        // Company
        if (data.role?.isCompany) {
          if (!environment.stringCheck(data.company)) {
            errors.push({
              field: 'company',
              text: 'You should to select Company'
            })
          }
        }
      }
    }

    // Address
    if (!environment.stringCheck(data.address?.address1)) {
      errors.push({
        field: 'address1',
        text: 'You should to fill Address field'
      })
    }
    // ZipCode
    if (!environment.stringCheck(data.address.zipCode)) {
      errors.push({
        field: 'zipCode',
        text: 'You should to fill ZipCode field'
      })
    }
    // City
    if (!environment.stringCheck(data.address.city)) {
      errors.push({
        field: 'city',
        text: 'You should to fill City field'
      })
    }
    // State
    if (!environment.stringCheck(data.address.state)) {
      errors.push({
        field: 'state',
        text: 'You should to fill State field'
      })
    }

    // Email
    if (!environment.stringCheck(data.email)) {
      errors.push({
        field: 'email',
        text: 'You should to fill Email field'
      })
    } else {
      if (!environment.emailValid(data.email)) {
        errors.push({
          field: 'email',
          text: 'Check Email and try again'
        })
      } else if (data.email.length > 50) {
        errors.push({
          field: 'email',
          text: 'Email must be less than 50 characters'
        })
      }
    }
    // Phone
    if (!environment.stringCheck(data.contacts.phone)) {
      errors.push({
        field: 'phone',
        text: 'You should to fill Phone field'
      })
    }
    // Fax
    // if (!environment.stringCheck(data.contacts?.fax)) {
    //   errors.push({
    //     field: 'fax',
    //     text: 'You should to fill Fax field'
    //   })
    // }


    // Password
    const pwdCheck = () => {
      if (!(data.pwd1?.length >= 8 && data.pwd1 === data.pwd2)) {
        errors.push({
          field: 'password',
          text: 'Check the Password fields and try again'
        })
      }
    }
    if (isEditMode) {
      if (data.pwd1) {
        pwdCheck()
      }
    } else {
      pwdCheck()
    }
    return new Promise((resolve, reject) => {
      if (errors.length === 0) {
        resolve(true)
      } else {
        reject(errors)
      }
    })
  }

  constructor() {
  }
}
